// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5z-1";
export var standaloneTable = "_5z-0";